define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react-draft-wysiwyg/dist/react-draft-wysiwyg.css", "draft-js", "react", "react-draft-wysiwyg", "draftjs-to-html", "html-to-draftjs", "./CustomOption", "./Wrapper", "./Mark", "./utils"], function (_exports, _extends3, _objectWithoutPropertiesLoose2, _reactDraftWysiwyg, _draftJs, _react, _reactDraftWysiwyg2, _draftjsToHtml, _htmlToDraftjs, _CustomOption, _Wrapper, _Mark, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _extends3 = _interopRequireDefault(_extends3);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireWildcard(_react);
  _draftjsToHtml = _interopRequireDefault(_draftjsToHtml);
  _htmlToDraftjs = _interopRequireDefault(_htmlToDraftjs);
  _CustomOption = _interopRequireDefault(_CustomOption);
  _Wrapper = _interopRequireDefault(_Wrapper);
  _Mark = _interopRequireDefault(_Mark);
  var _excluded = ["content", "changeContent", "newContent", "customVariableLabel", "variables"];

  var RichTextEditor = function RichTextEditor(_ref) {
    var content = _ref.content,
        changeContent = _ref.changeContent,
        newContent = _ref.newContent,
        customVariableLabel = _ref.customVariableLabel,
        variables = _ref.variables,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    var contentBlock = (0, _htmlToDraftjs.default)(content);

    var contentState = _draftJs.ContentState.createFromBlockArray(contentBlock.contentBlocks);

    var _useState = (0, _react.useState)(contentBlock ? _draftJs.EditorState.createWithContent(contentState) : _draftJs.EditorState.createEmpty()),
        editorState = _useState[0],
        setEditorState = _useState[1];

    var _getDecorators = function _getDecorators() {
      var variableObject = variables.reduce(function (acc, n) {
        var _extends2;

        return (0, _extends3.default)({}, acc, (_extends2 = {}, _extends2[n.value] = true, _extends2));
      }, {});
      var highlighterConfig = {
        component: _Mark.default,
        variables: variableObject,
        regex: new RegExp(/{{\s*([^}]+)\s*}}/, 'g')
      };
      return (0, _utils.generateVariableHighlighterPlugin)(highlighterConfig);
    };

    var insertBlocksFromHtml = function insertBlocksFromHtml(htmlString) {
      var contentBlock = (0, _htmlToDraftjs.default)(htmlString);

      var contentState = _draftJs.ContentState.createFromBlockArray(contentBlock.contentBlocks);

      var editorState = _draftJs.EditorState.createWithContent(contentState);

      setEditorState(editorState);
      changeContent((0, _draftjsToHtml.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent())));
    };

    var onEditorStateChange = function onEditorStateChange(editorState) {
      setEditorState(editorState);
      changeContent((0, _draftjsToHtml.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent())));
    };

    (0, _react.useEffect)(function () {
      insertBlocksFromHtml("<p>" + newContent + "</p>");
    }, [newContent]);
    return /*#__PURE__*/_react.default.createElement(_Wrapper.default, null, /*#__PURE__*/_react.default.createElement(_reactDraftWysiwyg2.Editor, (0, _extends3.default)({
      editorState: editorState,
      wrapperClassName: "vg-editor-wrapper",
      editorClassName: "vg-editor",
      toolbarClassName: "vg-editor-toolbar",
      spellCheck: true,
      onEditorStateChange: onEditorStateChange,
      toolbarCustomButtons: variables.length ? [/*#__PURE__*/_react.default.createElement(_CustomOption.default, {
        key: "customOption",
        customVariableLabel: customVariableLabel,
        variables: variables
      })] : [],
      customDecorators: variables.length ? _getDecorators() : [],
      localization: {
        locale: 'pt'
      },
      toolbar: {
        options: ['inline', 'fontSize', 'list', 'textAlign', 'link', 'history'],
        fontSize: {
          options: [8, 10, 12, 13, 14, 16, 18, 24, 30]
        },
        inline: {
          inDropdown: true
        },
        list: {
          inDropdown: true
        },
        textAlign: {
          inDropdown: true,
          options: ['left', 'center', 'right', 'justify']
        },
        link: {
          inDropdown: true
        }
      }
    }, rest)));
  };

  var _default = RichTextEditor;
  _exports.default = _default;
});